const pathDiseaseDetail = ({ slug }) => `/disease/detail/${slug}/`

export { pathDiseaseDetail }
